var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comp,_vm._b({tag:"component",staticClass:"component_class",style:('background:' + _vm.colors.background + '; padding:0%;')},'component',_vm.colors,false))}
var staticRenderFns = []

export { render, staticRenderFns }